import { c as _c } from "react/compiler-runtime";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { bulkActionNameSelector, selectedRowIdsSelector } from "@store/table/table-selector";
import { setInitialFetchingItems } from "@store/table/table-slice";
import { useEffect } from "react";

/**
 * Removes the members that are no longer shown, e.g. because the search hides them, from the
 * table selection. The bulk actions read the selection from the store, so without this they would
 * still act on the hidden members. The desktop grid already drops them on its own, the mobile list
 * does not.
 * While a bulk action runs the selection is kept, as the grid does, because the action can make its
 * own rows leave the list and the dialog reporting the result relies on the selection.
 */
export function useDeselectHiddenMembers(shownMembers) {
  const $ = _c(6);
  const dispatch = useAppDispatch();
  const selectedRowIds = useAppSelector(selectedRowIdsSelector);
  const bulkActionName = useAppSelector(bulkActionNameSelector);
  let t0;
  let t1;
  if ($[0] !== bulkActionName || $[1] !== dispatch || $[2] !== selectedRowIds || $[3] !== shownMembers) {
    t0 = () => {
      if (bulkActionName !== null) {
        return;
      }
      const shownSelectedRowIds = selectedRowIds.filter(id => shownMembers.some(member => member.identity === id));
      if (shownSelectedRowIds.length !== selectedRowIds.length) {
        dispatch(setInitialFetchingItems(shownSelectedRowIds));
      }
    };
    t1 = [bulkActionName, dispatch, selectedRowIds, shownMembers];
    $[0] = bulkActionName;
    $[1] = dispatch;
    $[2] = selectedRowIds;
    $[3] = shownMembers;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
}